var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBackbone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60938 0.710938C7.89062 0.453125 8.33594 0.453125 8.61719 0.710938L13.4922 5.21094C13.7266 5.42188 13.7969 5.75 13.6797 6.03125C13.5859 6.3125 13.3047 6.5 13 6.5H12.25V9.125C12.25 9.75781 11.7344 10.25 11.125 10.25H7.1875C6.625 7.95312 4.82031 6.125 2.52344 5.5625C2.54688 5.44531 2.61719 5.30469 2.73438 5.21094L7.60938 0.710938ZM7.375 5C7.16406 5 6.97656 5.1875 6.97656 5.375V6.875C6.97656 7.08594 7.16406 7.25 7.375 7.25H8.875C9.0625 7.25 9.25 7.08594 9.25 6.875V5.375C9.25 5.1875 9.0625 5 8.875 5H7.375ZM6.25 11.9375C6.25 12.2656 5.99219 12.5 5.6875 12.5C5.35938 12.5 5.125 12.2656 5.125 11.9375C5.125 9.57031 3.17969 7.625 0.8125 7.625C0.484375 7.625 0.25 7.39062 0.25 7.0625C0.25 6.75781 0.484375 6.5 0.8125 6.5C3.8125 6.5 6.25 8.9375 6.25 11.9375ZM0.25 11.75C0.25 11.3516 0.578125 11 1 11C1.39844 11 1.75 11.3516 1.75 11.75C1.75 12.1719 1.39844 12.5 1 12.5C0.578125 12.5 0.25 12.1719 0.25 11.75ZM0.25 9.3125C0.25 9.00781 0.484375 8.75 0.8125 8.75C2.57031 8.75 4 10.1797 4 11.9375C4 12.2656 3.74219 12.5 3.4375 12.5C3.10938 12.5 2.875 12.2656 2.875 11.9375C2.875 10.8125 1.9375 9.875 0.8125 9.875C0.484375 9.875 0.25 9.64062 0.25 9.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackbone);
export default __webpack_public_path__ + "static/media/IconBackbone.c48a6746ede19f745dc29a9d56c579ff.svg";
export { ForwardRef as ReactComponent };